import React, { useContext } from "react";
import {createPortal} from 'react-dom';
import { useForm, FormProvider } from 'react-hook-form';
import {bssMakeStyles}  from '../../lib/theming';
import Wrapper, { WaitKC } from '../Wrapper';
import useBSSLogger from "../../hooks/useBSSLogger";

const {logger} = useBSSLogger();

import { Box, Button, Card, Grid, Link } from '@mui/material';

import __t from "../../lib/traduzioni";

import BSSPreventivoContext from "../../contexts/BSSPreventivoContext";
import { useLocalStorage } from "react-use";
import FrammentoFatturazione from "./frammenti/FrammentoFatturazione";
import FrammentoPagamenti from "./frammenti/FrammentoPagamenti";
import FrammentoCarrello from "./frammenti/FrammentoCarrello";
import { AccountCircleOutlined } from "@mui/icons-material";
import { convertiFormRequestCalcola, DefaultSubmitErrorHandler } from "./Preventivo";
import { orderFromCart } from "../../api/testataordine";
import BSSForm from "../form/BSSForm";
import { datiFattDaContesto } from "../account/DatiFatturazione";


const FormPagamenti = ({destCarrello = null, destFatturazione = null, step=4, defaultValues, daShortcode, aggiornaPreventivoStorage, nextUrl = null, ...rest}) => {
    
    const contesto = useContext(BSSPreventivoContext);

    const [carrelloStorage = {preventivi: [], pagamenti: {}, datiFatturazione: {}}, aggiornaCarrelloStorage, rimuoviCarrelloStorage] = useLocalStorage("spedizioniweb2_preventivo_carrello");


    const {preventivoStorage = {}, rimuoviPreventivoStorage, datiFatturazione, tipiPersone} = contesto;

    const props = {destCarrello, destFatturazione};
    const dests = ["Carrello", "Fatturazione"];

    const usePortals = dests.reduce((obj, dest) => {
        const selector = props[`dest${dest}`];
        const destel = document.querySelector(`#${selector}`);
        const esito = (selector !== null && destel !== null) ? destel : false;
        logger.finest({dest, selector, destel, esito})
        return {
            ...obj,
            [dest]: esito
        }
    }, {})

    const classes = bssMakeStyles();

    const gruppooana = (datiFatturazione?.gruppo ?? null) === null ? 'anagrafica' : 'gruppo';

    defaultValues = {
        ...defaultValues, 
        datifatt: {
            ...(defaultValues.datifatt ?? {}),
            email: spedizioniweb2?.user?.data?.user_email ?? "",
            ...datiFattDaContesto(datiFatturazione, tipiPersone, gruppooana)
        },
        pagamenti: {
            pagamentoFineMese: true
        }            
    }

    logger.debug("inizializzo il form dello step 3 con i dati default", defaultValues)
    const methods = useForm({
        defaultValues,
        reValidateMode: 'onBlur'
    });
    const {handleSubmit, formState, control} = methods;
    

    //@deprecated - non utilizzato
    const onSubmit = async (data) => {
        logger.info("=======> dati form pagamenti: ", data);

        const dati = {
            carrello: {
                preventivi: carrelloStorage.preventivi.map(preventivo => convertiFormRequestCalcola(preventivo)),
                datiFatturazione: data.datifatt
            },
            pagamenti: data.pagamenti
        }        

        logger.info("=======> dati da mandare al server: ", dati);

        await orderFromCart(dati)
        
        //dopo aver creato l'ordine posso eliminare il carrello, i preventivi in corso e rimandare l'utente allo storico degli ordini
        rimuoviPreventivoStorage()
        rimuoviCarrelloStorage()



        // if(nextUrl === null || nextUrl === undefined){

        //     nextUrl = nextUrlByStep(5, [{tipo: "success", messaggio: __t("creatonuovoordine")}])                    

        // }

        // if(nextUrl !== null) {
                        
        //     location.href = nextUrl
        // }

        //location.href = getNextUrl(nextUrl, 5, [{tipo: "success", messaggio: __t("creatonuovoordine")}])

        return true

    }

    const onSubmitError = async (err) => {
        logger.info("=======>errore dati form pagamenti: ", err);
        throw(err)
    }

    const fragmentDefualtProps = {
        methods,
        classes,
        carrelloStorage,
        aggiornaPreventivoStorage,
        onSubmit,
        step
    }

    const submitProps = {
        ...fragmentDefualtProps, 
        onSubmit: handleSubmit(onSubmit, DefaultSubmitErrorHandler) //funzionamento standard
        // onSubmit: contesto => {
        //     logger.debug("effettuo submit con handlesubmit passando il contesto", contesto)
        //     handleSubmit(data => onSubmit(data, contesto), err => onSubmitError(err))
        // }
    }    

    const popolaDemo = () => {
        
        methods.setValue("datifatt", {
            ragionesociale: "Mario Rossi",            
            partitaiva: "IT123456789",
            pec: "bss@pec.it",
            codiceSdi: "1234567",
            vies: true,            
            provincia: {iso: "RG"},
            cap: "97100",
            citta: "Ragusa",
            prefissotelefono: "0932",
            numerotelefono: "246442",
            indirizzofatturazione: "via Giulio Pastore",
            civico: "1"
        })
        
    }

    return (
        <>
            {/* <Button color="primary" variant="contained" onClick={e => popolaDemo()}>Popola con dati fittizi</Button> */}

            <FormProvider {...methods}>

                <BSSForm onSubmit={handleSubmit(onSubmit, DefaultSubmitErrorHandler)}>                    

                    <Grid container >


                        {!spedizioniweb2.isloggedin() && (<AccediORegistrati />)}

                        <>  
                            {(usePortals["Carrello"] !== false)?
                                createPortal(
                                    <Wrapper inPortal>
                                        <FrammentoCarrello {...fragmentDefualtProps} />                                        
                                    </Wrapper>,                                    
                                    usePortals["Carrello"]
                                )
                                : 
                                <Box px={1} mb={3} width={1}>                                    
                                    <Card>
                                        <FrammentoCarrello {...fragmentDefualtProps} />
                                    </Card>                  
                                </Box>              
                            }
                        </> 
                        <WaitKC>
                            <>
                                <>  
                                    {(usePortals["Fatturazione"] !== false)?
                                        createPortal(
                                            <Wrapper inPortal>
                                                <FrammentoFatturazione {...fragmentDefualtProps} />                                        
                                            </Wrapper>,                                    
                                            usePortals["Fatturazione"]
                                        )
                                        : 
                                        <FrammentoFatturazione {...fragmentDefualtProps} />

                                        
                                    }
                                </>                        
                                <>
                                    <FrammentoPagamenti {...fragmentDefualtProps} />
                                </>
                            </>
                        </WaitKC>  
                        
                    </Grid>
                </BSSForm>
            </FormProvider>

        </>
    )
}


const AccediORegistrati = ({redirectTo = null}) => {

    let url = spedizioniweb2.getLoginUrl({redirectTo})

    return (
        <>
            <Box px={3} mb={3} width={1}>    
                <Link href={`${url}`}>
                    <Button size="large" style={{padding: "1em", fontSize: "1.5em", fontWeight: "bolder"}} variant="contained" color="primary" fullWidth >
                        <AccountCircleOutlined />
                        {`${__t("accedi")} ${__t("o")} ${__t("registrati")}`}
                    </Button>
                </Link>
                
            </Box>
        </>
    )
}

export default FormPagamenti
export {AccediORegistrati}
